import React from "react";
import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { IOrderLineItemDiscount, IPurchaseStateLineItemDiscount } from "@smartrr/shared/interfaces/Discount";
import { formatMoney } from "@smartrr/shared/utils/formatMoney";
import { CurrencyCode } from "@smartrr/shared/currencyCode";
import { IPurchaseStateLineItem } from "@smartrr/shared/entities/PurchaseState/CustomerPurchaseLineItem";
import { ISmartrrOrderLineItem } from "@smartrr/shared/entities/OrderLineItem";

interface OrderItemVariantDiscountPricingProps {
  appliedDiscounts: IPurchaseStateLineItemDiscount[] | IOrderLineItemDiscount[];
  item: ISmartrrOrderLineItem;
  subscriptionItemFromItem: IPurchaseStateLineItem;
  orderCurrency: CurrencyCode;
}

export const OrderItemVariantDiscountPricing = ({
  appliedDiscounts,
  item,
  subscriptionItemFromItem,
  orderCurrency,
}: OrderItemVariantDiscountPricingProps) => {
  const endingPrice = formatMoney(item.price - item.discountAmount / item.quantity, orderCurrency);
  return (
    <Stack
      direction="row"
      sx={{ marginBottom: "3px", flexWrap: "wrap" }}
      className={prefixClassName("order-sub-applied-discount-pricing")}
    >
      <Typography
        variant="caption1"
        sx={{
          textDecoration: "none",
          marginRight: "3px",
        }}
        className={prefixClassName("order-product-ending-price")}
      >
        {endingPrice}
      </Typography>
      <Typography
        variant="caption1"
        sx={{
          textDecoration: appliedDiscounts.length ? "line-through" : "none",
          opacity: "70%",
        }}
        className={prefixClassName("order-product-base-price")}
      >
        {formatMoney(subscriptionItemFromItem?.basePrice, orderCurrency)}
      </Typography>
    </Stack>
  );
};
